import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { Memo } from "src/openapi"
import { Box, Grid, Typography } from "src/UILibrary"

type Props = {
  item: Memo
  handleEdit: any
  handleRemove: any
}

export const MemoTableItem = ({ item, handleEdit, handleRemove }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.user" })

  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  return (
    <Box>
      {isTablet ? (
        <Grid
          container
          sx={{
            mt: "0px",
            borderBottom: "1px dotted #D4D3D7",
            minHeight: "80px",
          }}
        >
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.createdAt?.slice(0, 16).replace("T", " ")}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={13}
            sx={{ my: "auto", px: "20px" }}
          >
            {`${item.admin?.lastName} ${item.admin?.firstName}`}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 5 : isTablet ? 3 : 1}
            sm={12}
            xs={12}
            fontSize={13}
            sx={{
              my: "auto",
              px: "20px",
              whiteSpace: "pre-wrap",
            }}
          >
            {item.memo}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 3 : isTablet ? 4 : 1}
            sm={12}
            xs={12}
            fontSize={12}
            sx={{ my: "auto", px: "20px" }}
          >
            <Box display="flex">
              <Typography.DetailText
                fontSize={13}
                sx={{
                  fontFamily: "Noto Sans JP !important",
                  ":hover": { opacity: 0.8, cursor: "pointer" },
                }}
                onClick={() => handleEdit(item)}
              >
                {t("edit")}
              </Typography.DetailText>

              <Typography.DetailText
                fontSize={13}
                sx={{
                  fontFamily: "Noto Sans JP !important",
                  color: "#FC3317",
                  ml: "20px",
                  ":hover": { opacity: 0.8, cursor: "pointer" },
                }}
                onClick={() => handleRemove()}
              >
                {t("delete")}
              </Typography.DetailText>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Box display="display" sx={{ borderBottom: "1px dotted #D4D3D7" }}>
          <Box display="flex">
            <Box
              className="notosans weight500"
              color="text.primary"
              fontSize={14}
              sx={{ mt: "10px", ml: "10px" }}
            >
              {item.createdAt?.slice(0, 16).replace("T", " ")}
            </Box>
            <Box sx={{ mt: "12px", ml: "30px", width: "100%" }}>
              {`${item.admin?.lastName} ${item.admin?.firstName}`}
            </Box>
          </Box>
          <Box sx={{ p: "10px", whiteSpace: "pre-wrap" }}> {item.memo}</Box>
          <Box sx={{ p: "0px 10px", mb: "10px" }}>
            <Box display="flex">
              <Typography.DetailText fontSize={13} sx={{ fontFamily: "Noto Sans JP !important" }}>
                {t("edit")}
              </Typography.DetailText>

              <Typography.DetailText
                fontSize={13}
                sx={{ fontFamily: "Noto Sans JP !important", color: "#FC3317", ml: "20px" }}
              >
                {t("delete")}
              </Typography.DetailText>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
